import { BlueButton } from "@/components/generic/BlueButton"

export function HeaderButtonReferAFriend() {
  return (
    <BlueButton data-testid="btn-refer-friend" aria-label="Refer a Friend" className="!px-3" leftSection={<span>🎁</span>}>
      Refer a Friend
    </BlueButton>
  )
}
